import * as React from 'react';
import { DataGrid } from '@material-ui/data-grid';

function FinancialFilingDataGrid({data} :any) {

  const columns = [
    { field: 'id', hide: true },
    { field: 'filingDate', width: 100, headerName: 'Date', sortable: true, renderHeader:(params) => ( <strong>Date</strong>)},
    { field: 'filing', width: 180, headerName: 'Filing', sortable: false, renderHeader:(params) => ( <strong>Filing</strong>),renderCell: (params) => (<a target="_blank" rel="noopener noreferrer" href={ params.getValue(params.id, 'url') }>{params.value}</a>)},
    { field: 'formType', hide: true},
    { field: 'url', hide: true}
  ]

  function buildCompanyData(item) {
    return {
      id: item.id,
      filingDate: item.last_modified_date,
      filing: item.filing_name,
      formType: item.form_type,
      url: item.url
    }
  }

  const rows = data?.map(item => buildCompanyData(item));

  return (
    <div className="row">
      <DataGrid
        rows={rows}
        columns={columns}
        pageSize={6}
        rowsPerPageOptions={[6]}
        autoHeight={true}
        autoPageSize={true}
        density={"compact"}
        disableColumnMenu
      />
    </div>
  );
}

export default FinancialFilingDataGrid;
